import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useBatchId } from '../../../hooks/useBatchId';
import { useToastMessage } from '../../../hooks/useToastMessage';
import {
	CentralTeamDashboardFilter,
	PreceptorApplicationCentralTeamDashboardResponse,
} from '../../../shared/ScreeningServiceTypes';
import { getCentralTeamDashboardDetail } from '../../../service/ScreeningService';
import { ApplicationStatusType } from '../../../shared/VolunteerApplicationServiceTypes';

export const useCentralTeamDashboard = () => {
	const { srcmId } = useAuth();
	const { batchId } = useBatchId();
	const { showToastMessage } = useToastMessage();
	const [CTDDetail, setCTDDetail] =
		useState<PreceptorApplicationCentralTeamDashboardResponse>();
	const [CTDFilter, setCTDFilter] = useState<CentralTeamDashboardFilter>({
		batchId: [batchId],
	});

	const onCTDFilterChange = useCallback(
		(filterParam: CentralTeamDashboardFilter) => {
			setCTDFilter(filterParam);
		},
		[]
	);

	const getCTDDetail = useCallback(
		async (filter: CentralTeamDashboardFilter) => {
			if (srcmId && batchId) {
				try {
					const request = {
						...filter,
						functionarySrcmId: srcmId,
						applicationStatus: [
							'APPROVED',
							'REJECTED',
						] as ApplicationStatusType[],
					};
					const CTDResponse = await getCentralTeamDashboardDetail(request);

					if (CTDResponse) {
						setCTDDetail(CTDResponse);
					}
				} catch (err) {
					showToastMessage(
						'error',
						err instanceof Error ? err.message : 'Unknown error occurred'
					);
				}
			}
		},
		[srcmId, batchId, showToastMessage]
	);

	useEffect(() => {
		void getCTDDetail(CTDFilter);
	}, [CTDFilter, getCTDDetail]);

	return {
		CTDDetail,
		CTDFilter,
		onCTDFilterChange,
	};
};
